<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'ops-task-rule-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <ng-container *ngIf="!loading && task; else loadingArea">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs></sbnb-page-header>
      </app-feature-flag-tabs>

      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
          <mat-slide-toggle [checked]="task.active" (change)="activateOrDeactivateRule($event)"></mat-slide-toggle>
          <h2 fxFlex class="nomargin input__editable">
            <input
              #nameInput
              class="input__borderless"
              type="text"
              [style.width.px]="nameInput.value.length * 13"
              [(ngModel)]="task.name"
              (change)="triggerSave()" />
          </h2>

          <sbnb-cs-debug-item
            label="Task Rule UUID"
            [coreNovaLink]="'/external/task-rule/' + task.uuid"
            [value]="task.uuid"
            linkLabel="Nova"></sbnb-cs-debug-item>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <img src="/assets/iconography/task-rules.svg" />
            <span *ngIf="!task.metadata.recurring">{{ task.task_type_string }} task</span>
            <span *ngIf="task.metadata.recurring">Recurring {{ task.task_type_string | lowercase }} task</span>
          </h3>

          <span class="text__small">
            This rule will create {{ task.metadata.recurring ? 'recurring ' : null }} tasks for
            {{ task.task_type_string | lowercase }} teammates.
          </span>
        </div>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <img src="/assets/iconography/settings.svg" />
            <span>Duration</span>
          </h3>

          <mat-slider
            fxFlex
            min="0"
            [max]="meta.durations.length - 1"
            step="1"
            [value]="durationIndex"
            (input)="durationSliderUpdated($event)"></mat-slider>
          <strong class="grass-darker" fxFlex="100px" fxLayoutAlign="end center">
            {{ meta.durations[durationIndex].label }}
          </strong>
        </div>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span data-intercom-target="task-rule-timing">Timing</span>
          </h3>
          <sbnb-task-rule-timing
            *ngIf="!task.metadata.recurring"
            [timingMeta]="meta.timings"
            [ruleset]="task"
            (triggerSave)="timingUpdated($event)"></sbnb-task-rule-timing>
          <sbnb-task-rule-timing-recurring
            *ngIf="task.metadata.recurring"
            [meta]="meta.timings"
            [ruleset]="task"
            (triggerSave)="timingUpdated($event)"></sbnb-task-rule-timing-recurring>
        </div>
      </div>

      <div class="rule__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <img src="/assets/iconography/settings.svg" />
            <span>Checklist</span>
          </h3>
          <span class="text__small">You can add a checklist for this task.</span>
        </div>

        <div class="rule__scope-box">
          <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header"></div>
          <div>
            <div>
              <mat-form-field class="fw input__mini">
                <sbnb-icon matPrefix icon="edit" class="text-smoke-darker"></sbnb-icon>

                <input
                  matInput
                  [(ngModel)]="taskEntry"
                  (keydown.enter)="saveTask()"
                  (blur)="saveTask()"
                  [placeholder]="placeholderText || 'Enter a task and tap enter to add'" />
              </mat-form-field>
            </div>

            <div class="tasks-list-body">
              <ng-container *ngIf="task && task.task_list && task.task_list.length > 0; else noTaskData">
                <ng-container *ngFor="let task of task.task_list; let i = index">
                  <div fxLayout fxLayoutGap="4px" fxLayoutAlign="start center" class="task__list">
                    <span fxLayout fxFlex fxLayoutGap="8px" fxLayoutAlign="start center" class="task__entry">
                      <input
                        type="text"
                        class="fw"
                        [ngModel]="task.entry | humanize"
                        (ngModelChange)="task.entry = $event"
                        (change)="updateTask()" />
                    </span>
                    <sbnb-more-menu-trigger [matMenuTriggerFor]="taskActionsMenu"></sbnb-more-menu-trigger>
                    <mat-menu #taskActionsMenu="matMenu">
                      <button mat-menu-item (click)="deleteTask(task.id)">
                        <span fxLayoutAlign="start center" fxLayoutGap="6px">
                          <img src="/assets/iconography/delete.svg" alt="Delete" />
                          <span>Delete</span>
                        </span>
                      </button>
                    </mat-menu>
                  </div>
                </ng-container>
              </ng-container>

              <ng-template #noTaskData>
                <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
                  <div>
                    <svg width="40" height="40" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
                        stroke="#E5E2E9"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M75.7819 30.169V79.0313H14.6938V30.1487"
                        stroke="#E5E2E9"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
                        fill="#D0CDD4" />
                    </svg>
                  </div>

                  <h5>No checklist found</h5>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <sbnb-icon icon="scope" [size]="20" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
          </h3>
          <span class="text__small">This task rule will be generating tasks for those properties.</span>
        </div>

        <div class="rule__scope-box">
          <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header">
            <mat-checkbox [checked]="task.all_properties" (change)="allPropertyChange($event)">
              <h4 fxFlex>Properties</h4>
            </mat-checkbox>
            <span *ngIf="!task.all_properties">{{ task.properties?.length }} selected</span>
            <span *ngIf="task.all_properties">All properties</span>
          </div>
          <div
            [style.opacity]="task.all_properties ? 0.2 : 1"
            [style.pointer-events]="task.all_properties ? 'none' : null">
            <div>
              <sbnb-search-bar
                placeholderText="Search..."
                (searchChanged)="searchCriteriaProperties = $event"></sbnb-search-bar>
            </div>
            <div class="rules__scrollable">
              <ng-container *ngFor="let property of possibleProperties">
                <div
                  *ngIf="property.name | matchPropertySearchCriteria: searchCriteriaProperties"
                  fxLayout
                  fxLayoutGap="4px"
                  fxLayoutAlign="start center">
                  <mat-checkbox
                    style="width: 100% !important"
                    [checked]="task.all_properties || task.properties.indexOf(property.id) > -1"
                    (change)="propertyCheckboxChange(property, $event)">
                    <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                      <img [src]="property.picture" class="property__img" />
                      <span fxFlex>{{ property.name }}</span>
                    </span>
                  </mat-checkbox>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <img src="/assets/iconography/team.svg" width="19" height="19" />
            <span>Assignment</span>
          </h3>
          <span fxHide.lt-md class="text__small">
            Tasks generated by this rule can be assigned to a teammate, or you can choose later.
          </span>
        </div>

        <mat-radio-group [(ngModel)]="task.assignment" (ngModelChange)="assignmentChange($event)">
          <div>
            <mat-radio-button value="manual">
              <div fxLayout fxLayoutGap="24px">
                <span>Manual</span>
                <span class="text__small">I'll assign tasks to a teammate later.</span>
              </div>
            </mat-radio-button>
          </div>
          <div fxLayout fxLayoutAlign="start center">
            <mat-radio-button value="teammate">
              <div fxLayout fxLayout.lt-md="row wrap" fxLayoutGap="24px">
                <span>Auto</span>
                <span class="text__small">I want to assign tasks directly to</span>
                <span class="clickable ocean text__small strong" [matMenuTriggerFor]="teamMenu">
                  {{ task.teammate_name ? task.teammate_name : 'choose a teammate' }}
                </span>
              </div>
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>

      <mat-menu #teamMenu="matMenu" class="filters__cdk-menu" yPosition="below" xPosition="before">
        <div *ngIf="!possibleTeammates || possibleTeammates.length === 0" style="padding: 0 16px">
          <p>No {{ task.task_type_string | lowercase }} teammates found.</p>
          <p>
            <a [routerLink]="['/operations/team/create']" class="raspberry-darker strong">Create a teammate</a>
            to start assigning {{ task.task_type_string | lowercase }} tasks.
          </p>
        </div>

        <input
          *ngIf="possibleTeammates && possibleTeammates.length >= numListOptionsForSearchBar"
          class="filters__input-list-search"
          [(ngModel)]="searchCriteria"
          type="text"
          placeholder="Search"
          (click)="$event.stopPropagation()" />

        <div class="filter__list-fixed-height" *ngIf="possibleTeammates && possibleTeammates.length > 0">
          <ng-container *ngFor="let member of possibleTeammates">
            <button
              mat-menu-item
              (click)="selectedTeamMember(member)"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="8px">
              <sbnb-team-icon [member]="member"></sbnb-team-icon>
              <span>{{ member.name }}</span>
            </button>
          </ng-container>
        </div>
        <div
          *ngIf="possibleTeammates && possibleTeammates.length === 0"
          class="properties__no-listings text__small"></div>
      </mat-menu>

      <div class="rule__section-container" fxLayout fxLayoutAlign="start center">
        <button [disabled]="copying" class="button__text night" mat-flat-button (click)="copyRuleset()">
          <img src="/assets/iconography/copy.svg" />
          Copy
        </button>

        <button
          [disabled]="deleting"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          [disabled]="deleting"
          class="button__text ocean"
          mat-flat-button
          (click)="deletePrompt()">
          <img src="/assets/iconography/delete.svg" />
          Delete
          <mat-spinner *ngIf="deleting" class="button__spinner" [diameter]="30"></mat-spinner>
        </button>

        <span fxFlex></span>

        <div fxLayout fxLayoutAlign="end center">
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingArea>
      <mat-spinner diameter="30"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
